import { globalPolyfills } from './core';

globalPolyfills().then(() => import(/* webpackChunkName: "global" */'./core/global'));
